import React from 'react';
import Modal from './Modal';
import './css/Modal.css';

const CartSuccessModal = ({ isOpen, onClose, onContinueShopping, onViewCart }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="장바구니에 추가되었습니다"
      description="상품이 장바구니에 성공적으로 추가되었습니다."
      showCloseButton
      titleAlign="left"
      footerAlign="right"
      footer={
        <>
          <button type="button" className="btn-confirm" onClick={onContinueShopping}>
            계속 쇼핑하기
          </button>
          <button type="button" className="btn-cancel" onClick={onViewCart}>
            장바구니 보기
          </button>
        </>
      }
    />
  );
};

export default CartSuccessModal;
